import { render } from "./TrafficGroupForm.vue?vue&type=template&id=1df4bd72&ts=true"
import script from "./TrafficGroupForm.vue?vue&type=script&lang=ts"
export * from "./TrafficGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__